import { render, staticRenderFns } from "./MotivoAlteracao.vue?vue&type=template&id=a9ce2f0c&"
import script from "./MotivoAlteracao.vue?vue&type=script&lang=js&"
export * from "./MotivoAlteracao.vue?vue&type=script&lang=js&"
import style0 from "./MotivoAlteracao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports